import script from "./match-detail-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./match-detail-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__